import { useMutation } from '@tanstack/react-query';

import API from 'configs/API';
import { axiosPost } from 'utils/apis/axios';

const unLikeCollection = async (id) => {
  const { data } = await axiosPost(false, API.ARTWORK.UN_LIKE_COLLECTION(id));
  return data;
};

const useUnLikeCollection = () => {
  return useMutation({
    mutationFn: unLikeCollection,
  });
};

export default useUnLikeCollection;
